import styled from 'styled-components'
import { CustomerCustomComponents } from '../customerCustomComponents'
import { InitialButton as DefaultInitialButton } from '../../../Buttons'
import { UploadButton as DefaultUploadButton } from '../../../Upload/defaultComponents'
import {
  InfoContainer as DefaultInfoContainer,
  ButtonContainer as DefaultButtonContainer,
  InitialButtonContainer as DefaultInitialButtonContainer,
  PatientVerificationContainer as DefaultPatientVerificationContainer,
} from '../../../Containers'
import { HeaderContainer as DefaultHeaderContainer } from '../../../Headers/defaultComponents'

/**
 * This file defines the components and styles that are specific to this customer.
 * These custom components are based on parent components, which are used by default.
 */

/**
 * Customer logo
 */
export { default as CurativeLogo } from './logo.svg'

const BUTTON_PRIMARY_HOVER_BG = '#1C63EB'
const BUTTON_DISABLE_BG = '#D9DAE3'
const BUTTON_DISABLE_COLOR = '#53576A'

const PatientVerificationContainer = styled(
  DefaultPatientVerificationContainer
)`
  ${({ theme: { mainThemeColor } }) => {
    return `
      h2 {
        font-size: 1.875rem;
        font-family: 'Soehne-powerful';
        color: ${mainThemeColor};
      }

      h3,
      p {
        font-size: 1rem;
        line-height: 150%;
      }
      
      h3 {
        margin: 0 0 1rem 0;
        font-family: 'Soehne-powerful';
        font-weight: 400;
      }

      @media (min-width: 768px) {
        max-width: 600px;
        h2 {
          font-size: 2.25rem;
        }
      }
    `
  }}
`

const InitialButtonContainer = styled(DefaultInitialButtonContainer)`
  margin-top: 2rem;

  @media (min-width: 768px) {
    justify-content: end;
  }
`

const InitialButton = styled(DefaultInitialButton)`
  ${({ filled, theme: { mainThemeColor } }) => {
    return `
      width: 100%;
      border-radius: 0.25rem;
      font-family: 'Soehne-powerful'!important;
      @media (min-width: 768px) {
        width: auto;
      }
      ${
        filled
          ? `
            background-color: ${mainThemeColor};
            transition: all 0.3s ease;
            &:hover:not(:disabled) {
              background-color: ${BUTTON_PRIMARY_HOVER_BG};
            }

            &:disabled {
                color: ${BUTTON_DISABLE_COLOR};
                background-color: ${BUTTON_DISABLE_BG};
            }
          `
          : `
            background: none;
            color: ${mainThemeColor};
            text-decoration: underline;
            border: none;
          `
      }
    `
  }}
`
const NextBackButton = styled(InitialButton)`
  width: 100%;

  @media (min-width: 768px) {
    width: auto;
  }
`
const NextButton = styled(NextBackButton)``
const BackButton = styled(NextBackButton)``
const TakePhotoButton = styled(InitialButton)``
const UploadButton = styled(DefaultUploadButton)`
  font-family: 'Soehne-powerful' !important;
`

const ButtonContainer = styled(DefaultButtonContainer)`
  display: flex;

  button {
    width: 100%;
  }

  @media (min-width: 768px) {
    justify-content: end;
    button {
      width: auto;
    }
    button + button {
      margin-left: 2rem;
    }
  }
`

const HeaderContainer = styled(DefaultHeaderContainer)`
  ${({ theme: { mainThemeColor } }) => {
    return `
      h2 {
        font-size: 1.5rem;
        font-family: 'Soehne-powerful';
        color: ${mainThemeColor};
      }

      h3,
      p {
        font-size: 1rem;
        line-height: 150%;
      }
      
      h3 {
        margin: 0 0 1rem 0;
        font-family: 'Soehne-powerful';
      }

      @media (min-width: 768px) {
        max-width: 600px;
      }
    `
  }}
`

const InfoContainer = styled(DefaultInfoContainer)`
  h2 {
    font-family: 'Soehne-powerful';
    line-height: 150%;
  }

  li {
    font-size: 1rem;
    line-height: 150%;
  }
`

export const curativeCustomComponents: CustomerCustomComponents = {
  NextButton,
  BackButton,
  UploadButton,
  InitialButton,
  InfoContainer,
  TakePhotoButton,
  HeaderContainer,
  ButtonContainer,
  InitialButtonContainer,
  PatientVerificationContainer,
}
